import {LkNotificationListInterface, LkNotificationListParamsInterface} from "./LkNotificationListInterfaces";

const CACHE_KEY = 'lk_notification_list_cache';
const CACHE_TTL_MS = 8 * 60 * 60 * 1000; // 8 часов

interface CacheEntry {
    data: LkNotificationListInterface;
    timestamp: number;
    params: string;
}

class LkNotificationCacheService {
    get(params: LkNotificationListParamsInterface | void): LkNotificationListInterface | null {
        try {
            const raw = localStorage.getItem(CACHE_KEY);
            if (!raw) return null;

            const entry: CacheEntry = JSON.parse(raw);
            const isExpired = Date.now() - entry.timestamp > CACHE_TTL_MS;
            if (isExpired) return null;

            const paramsKey = JSON.stringify(params ?? null);
            if (entry.params !== paramsKey) return null;

            return entry.data;
        } catch {
            return null;
        }
    }

    set(params: LkNotificationListParamsInterface | void, data: LkNotificationListInterface): void {
        try {
            const entry: CacheEntry = {
                data,
                timestamp: Date.now(),
                params: JSON.stringify(params ?? null),
            };
            localStorage.setItem(CACHE_KEY, JSON.stringify(entry));
        } catch {
            // localStorage может быть недоступен (приватный режим)
        }
    }

    invalidate(): void {
        try {
            localStorage.removeItem(CACHE_KEY);
        } catch {
            // ignore
        }
    }
}

export const lkNotificationCacheService = new LkNotificationCacheService();
